const columnsTemp = [
    {
        name: 'No',
        title: '序号',
        sortAble: false,
    },
    {
        name: 'CompanyName',
        title: '公司名称',
        sortAble: false,
    },
    {
        name: 'PrecontractedDisclosureD',
        title: '申报日',
        sortAble: true,
    },
    {
        name: 'ExaminationMeetingDate',
        title: ' 上会日',
        sortAble: true,
    },
    {
        name: 'OnlineStartDate',
        title: '申购日期',
        sortAble: true,
    },
    {
        name: 'IssueShares',
        title: '拟发行数量',
        sortAble: true,
    },
    {
        name: 'IPOProceeds',
        title: '募资金额',
        sortAble: true,
    },

    {
        name: 'DeclareState',
        title: '当前状态',
        sortAble: false,
    },
    {
        name: 'Plate',
        title: '上市地点',
        sortAble: false,
    },
    {
        name: 'Sponsor',
        title: '保荐机构',
        sortAble: false,
    },
];

export default columnsTemp;
